import { Post } from "@forcode/domain";

import { Card } from "../../atom";
import { PostCardContent } from "./components/PostCardContent";
import PostCardMedia from "./components/PostCardMedia";
import css from "./PostCard.module.css";

export interface IPostCardProps {
  post: Post;
}

export const BASE_CLASS = "f-OrganismPostCard";

export const PostCard = ({ post }: IPostCardProps) => {
  return (
    <Card
      className={css[BASE_CLASS]}
      content={<PostCardContent {...{ post }} />}
      media={<PostCardMedia {...{ post }} />}
    />
  );
};
